module.exports = __webpack_public_path__ + "img/Cereza-temporada.c5867aa8.jpg";